export default __webpack_public_path__ + "static/silver-banner-5995881ee7d33aa5504a3d13250c211d.svg";